import type { ContentRecordDto, LocaleDto, WorkflowQueueItemDto } from "@/lib/schemas/content";
import type { WorkflowDto } from "@/lib/schemas/common";
import type { LocaleOption, ManagedContent, Workflow, WorkflowQueueItem } from "@/lib/domain/models";

export function toLocaleOption(dto: LocaleDto): LocaleOption {
  return { code: dto.code, name: dto.name, nativeName: dto.native_name, isDefault: dto.is_default, pathPrefix: dto.path_prefix };
}

export function toWorkflow(dto: ContentRecordDto["workflow"]): Workflow {
  return { id: dto.id, state: dto.status, label: dto.label, version: dto.version, actions: dto.allowed_actions, updatedAt: dto.updated_at ? new Date(dto.updated_at) : null, reviewNotice: dto.review_notice ?? null };
}

export function toWorkflowDto(value: Workflow, previous?: WorkflowDto): WorkflowDto {
  return {
    id: value.id,
    status: value.state,
    label: value.label,
    version: value.version,
    draft_version: previous?.draft_version ?? null,
    live_version: previous?.live_version ?? null,
    updated_at: value.updatedAt?.toISOString() ?? null,
    allowed_actions: [...value.actions],
    review_notice: value.reviewNotice ?? null,
  };
}

export function toManagedContent(dto: ContentRecordDto): ManagedContent {
  return {
    id: dto.id, locale: dto.locale, code: dto.canonical.code, categoryId: dto.canonical.category_id ?? null, parentId: dto.canonical.parent_id ?? null,
    depth: dto.canonical.depth ?? 0, order: dto.canonical.order, featured: dto.canonical.is_featured,
    archived: dto.canonical.is_archived, title: dto.fields.title, slug: dto.fields.slug,
    summary: dto.fields.summary, body: dto.fields.body ?? "", image: dto.image ?? "",
    mediaAssetId: dto.canonical.media_asset_id ?? null,
    imageAlt: dto.fields.image_alt, seoTitle: dto.fields.seo_title,
    seoDescription: dto.fields.seo_description,
    workflow: toWorkflow(dto.workflow), updatedAt: dto.updated_at ? new Date(dto.updated_at) : null
  };
}

export function toWorkflowQueueItem(dto: WorkflowQueueItemDto): WorkflowQueueItem {
  return {
    id: dto.id,
    title: dto.title,
    domain: dto.domain,
    domainLabel: dto.domain_label,
    locale: dto.locale,
    status: dto.status,
    statusLabel: dto.status_label,
    scheduledFor: dto.scheduled_for ? new Date(dto.scheduled_for) : null,
    updatedAt: new Date(dto.updated_at),
    path: dto.path,
    workflow: toWorkflow(dto.workflow),
  };
}
